import { Box, Button, Container, Typography, useMediaQuery } from '@mui/material';
import { RouterLink } from 'src/components/router-link';
import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { paths } from 'src/paths';
import localStrings from "../localStrings";

const Page = () => {
    const mdUp = useMediaQuery((theme) => theme.breakpoints.down('md'));

    usePageView();

    return (
        <>
            <Seo title="Error: Not Found" />
            <Box
                component="main"
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    py: '80px'
                }}
            >
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mb: 6
                        }}
                    >
                        <Box
                            alt="Not found"
                            component="img"
                            src="/assets/errors/error-404.png"
                            sx={{
                                height: 'auto',
                                maxWidth: '100%',
                                width: 400
                            }}
                        />
                    </Box>
                    <Typography
                        align="center"
                        variant={mdUp ? 'h1' : 'h4'}
                    >
                        {localStrings.notFoundPage}

                    </Typography>
                    <Typography
                        align="center"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                    >
                        {localStrings.notFoundPageExplanation}
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 6
                        }}
                    >
                        <Button
                            component={RouterLink}
                            href={paths.index}
                        >
                            {localStrings.backToHome}
                        </Button>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default Page;
